import * as types from '../types';
import { ICustomersApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class CustomersHttpApi extends HttpApi implements ICustomersApi {
  async listCustomers(page = 1, limit = 20): Promise<types.PaginatedResponse<types.Customer>> {
    const response = await this.http.get<types.PaginatedResponse<types.Customer>>(
      '/customers',
      { params: { page, limit } }
    );
    return response.data;
  }

  async getCustomer(id: string): Promise<types.Customer> {
    const response = await this.http.get<types.APIResponse<types.Customer>>(`/customers/${id}`);
    return response.data.data;
  }

  async createCustomer(data: types.CreateCustomerRequest): Promise<types.Customer> {
    const response = await this.http.post<types.APIResponse<types.Customer>>('/customers', data);
    return response.data.data;
  }

  async updateCustomer(id: string, data: types.UpdateCustomerRequest): Promise<types.Customer> {
    const response = await this.http.patch<types.APIResponse<types.Customer>>(`/customers/${id}`, data);
    return response.data.data;
  }
}
